import Event from "./Event";
import { apiURL } from "../helpers/url";

class Coupon extends Event {
    constructor() {
        super();
        this.apiURL = apiURL();
        this.coupon = {};
        this.promises = {
            fetchCoupon: null
        };
        this.AbortControllers = {
            fetchCoupon: []
        };
    }

    // Creating a global instance
    static createInstance() {
        return new this();
    }

    abortFetch(name) {
        Object.values(this.AbortControllers[name]).forEach(controller => controller.abort());
        this.AbortControllers[name] = [];
    }

    /**
     * Fetch Coupon item
     *
     * Coupon returns pending Promise if API request is pending
     *
     * @returns {Promise} Promise object with status and data
     */
    fetchCoupon(coupon, voucher) {
        this.publish("itemsFetching");

        // If fetching is already underway we cancel
        this.abortFetch("fetchCoupon");
        let controller = new AbortController();
        this.AbortControllers.fetchCoupon.push(controller);

        this.promises.fetchCoupon = fetch(`${this.apiURL}/coupon?name=${coupon}&voucher=${voucher}`, {
            signal: controller.signal
        })
            .then(response => {
                return response.text().then(text => {
                    return {
                        status: response.status,
                        content: text
                    };
                });
            })
            .then(response => {
                let content = response.status < 300 ? JSON.parse(response.content) : null;

                if (content) {
                    this.coupon = content;
                    this.publish("itemsFetched", {
                        status: response.status,
                        content: content
                    });
                }
                this.promises.fetchCoupon = null;

                return {
                    status: response.status,
                    content: content
                };
            })
            .catch(error => {
                this.promises.fetchCoupon = null;
                return {
                    status: 600,
                    error: error
                };
            });

        return this.promises.fetchCoupon;
    }
}

export default Coupon;
